Ext.define('SA.ComparisonViewController', {
    constructor({model, activeState}) {
        this.model = model;
        this.activeState = activeState;

        this.toolbar = new SA.view.ComparisonToolbar({model});

        this.createView();
        this.initEvents();
    },

    initEvents() {
        this.activeState.onActive(this.onActive, this);

        this.toolbar.on('click:transpose', this.onClickTranspose, this);
        this.toolbar.on('activate:exportBtn', this.onActivateExportBtn, this);

        this.model.on('remove', this.onModelDelete, this);
        this.model.on('change:filter', this.refreshFilterIndicator, this);
        this.model.on('change:filterVisibility', this.refreshFilterIndicator, this);
    },

    createView() {
        var xtype = this.model.isTransposed() ? 'comparison-report-transposed-grid' : 'comparison-report-grid';

        this.view = Ext.widget({xtype, projectView: this.model});
        this.projectView = SA.ProjectView.createHidden(this.view);
    },

    onActivateExportBtn(toolbarButton) {
        var config = new SA.ComparisonExportConfig({model: this.model});

        Ext.widget({xtype: 'arrow-export-menu', config, toolbarButton});
    },

    onActive() {
        SA.ProjectViewToolbar.setToolbar(this.toolbar);
        this.refreshFilterIndicator();

        this.showView();
    },

    onClickTranspose() {
        this.model.toggleTransposed();

        this.projectView.destroy();
        this.createView();
        this.showView();
    },

    onModelDelete() {
        this.toolbar.destroy();
        this.projectView.destroy();
    },

    refreshFilterIndicator() {
        this.toolbar.setFilteringButtonIndicatorVisible(this.model.isFiltered());
    },

    showView() {
        SA.ProjectView.show(this.projectView);
    }
});